import { Box, Grid, Icon, IconButton, Typography } from "@mui/material"
import dayjs from "dayjs"
import { Ref, createRef, forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { CustomTable } from "../../../../../../../components"
import { DinamicForm } from "../../../../../../../components/dinamicForm"
import { DateModalRangeRef } from "../../../../../../../components/dinamicForm/dateModal"
import { FiltersDrawer } from "../../../../../../../components/filtersDrawer"
import { RefTable } from "../../../../../../../components/table/types"
import { useFilter } from "../../../../../../../hooks/filter"
import { useContextState } from "../../../../../../../hooks/theme"
import { Constants } from "../../../../../../../utils/constants"
import { RequestErrors } from "../../../../../../../utils/enums"
import { icons } from "../../../../../../../utils/icons"
import { toUnitTimeZone } from "../../../../../../../utils/methods/calcDate"
import { handleAllErrors } from "../../../../../../../utils/methods/handleErrors"
import { ObjectGeneric, onChange } from "../../../../../../../utils/types/generals"
import { inputModel } from "./contants"
import { rowFilter } from "./methods"
import { useStyles } from "./styles"
import { MatchItemsProps, MatchItemsRef } from "./types"
import { ConfigCalendar } from "../configCalendar"
import { FrequencyEnum } from "../configCalendar/enums"
import { DaysWeek } from "../../../../../../reportFolio/pages/notifications/pages/main/utils/enums/tabs"
import { eachDayOfInterval } from "date-fns"

const MatchItems = forwardRef((props: MatchItemsProps, ref: Ref<MatchItemsRef>) => {
    const refRange = createRef<DateModalRangeRef>()
    const refTable = createRef<RefTable>()
    const { colors } = useContextState()
    const styles = useStyles()
    const filter = useFilter({ formatFilter: {} })
    const { t } = useTranslation()
    const [item, setItem] = useState<ObjectGeneric>({})
    const [disabledList, setDisabledList] = useState<(string | number)[]>(props?.dataDefault?.disabledList ?? props.listOfItemsToMatch?.map(match => match.id) ?? [])
    const [defaultChecks, setDefaultChecks] = useState<(string | number)[]>(props?.dataDefault?.defaultChecks ?? [])
    const [itemWithErrors, setItemsWithErrors] = useState<Record<string, string[]>>(props?.dataDefault?.itemWithErrors ?? {})
    const [errors, setErrors] = useState<Record<string, string>>({})
    const [data, setData] = useState<ObjectGeneric>({})
    const [dataList, setDataList] = useState<ObjectGeneric[]>(props?.dataDefault?.dataList ?? [])
    const [rows, setRows] = useState(props.listOfItemsToMatch || [])
    const handleCloseScheduleUser = () => {
        setData({})
        setItem({})
    }
    const localeRow = useMemo(() => {
        handleCloseScheduleUser()
        const list = rowFilter({ data: filter.filterData, rows })
        return list
    }, [rows, filter.filterData])

    const normalizeHex = (hex?: string | null) => {
        if (!hex) return undefined
        const clean = `${hex}`.trim().replace('#', '')
        if (!clean) return undefined
        return `#${clean}`
    }

    const storeStatusById = useMemo(() => {
        const map = new Map<string | number, any>()
            ; (props?.items?.stores ?? []).forEach((s: any) => {
                const key = s.value ?? s.id
                map.set(key, s.storeStatus)
            })
        return map
    }, [props?.items?.stores])

    const [selectedDays, setSelectedDays] = useState<number[]>([DaysWeek.MONDAY, DaysWeek.TUESDAY, DaysWeek.WEDNESDAY, DaysWeek.THURSDAY, DaysWeek.FRIDAY, DaysWeek.SATURDAY, DaysWeek.SUNDAY])
    const [flag, setFlag] = useState(true)
    const [children, setChildren] = useState<string[]>([])
    const childrenRef = useRef<string[]>([]);
    const [startDate, setStartDate] = useState<number | undefined>(undefined)
    const column = [
        {
            id: 'user',
            label: t('schedule.tables.userAssigned'),
            sortable: true,
            minWidth: 100,
            renderCell: (params: any) => {
                const { fullName, curp, id } = params.row
                return (
                    <Box sx={styles.users}>
                        <Typography>{fullName} - {curp}</Typography>
                        {itemWithErrors?.[id]?.map((codeError) => (
                            <Typography sx={styles.errorsText}>- {handleAllErrors(codeError as RequestErrors, t)}</Typography>
                        ))}
                    </Box>
                )
            },
        },
        {
            id: 'unity',
            label: t('schedule.tables.unity'),
            sortable: true,
            minWidth: 100,
            renderCell: (params: any) => {
                const { keyCode, storeName } = params.row
                const storeId = params.row.storeId ?? params.row.unityId ?? params.row.unidad_id ?? params.row.unidad

                const storeStatus = params.row.storeStatus ?? storeStatusById.get(storeId)
                const statusName = storeStatus?.name
                const color = normalizeHex(storeStatus?.color) ?? colors.color5

                return (
                    <Box sx={styles.users}>
                        <Typography>
                            {keyCode} - {storeName}
                            {!!statusName && (
                                <>
                                    {' - '}
                                    <Box
                                        component="span"
                                        sx={{
                                            color,
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        {statusName}
                                    </Box>
                                </>
                            )}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            id: 'questionarie',
            label: t('schedule.tables.questionarie'),
            sortable: true,
            minWidth: 120,
            renderCell: (params: any) => {
                const { id, questionnaireName } = params.row
                return (
                    <Box sx={styles.users}>
                        <Typography>
                            {questionnaireName}
                        </Typography>
                        {/* {itemWithErrors?.[id]?.map((codeError) => (
                            <Typography sx={styles.errorsText}>- {handleAllErrors(codeError as RequestErrors, t)}</Typography>
                        ))} */}
                    </Box>
                )
            },
        },
        {
            id: 'dateAndApplicated',
            label: t('useScheduled.detail.tables.frequency'),
            minWidth: 160,
            /* rowTdStyles: {
                maxWidth: '200px',
            },
            headerCell: {
                width: '200px'
            }, */
            renderCell: (params: any) => {
                const { row } = params
                const childrens = row?.children
                return (
                    <Box>
                        {childrens && childrens.length > 1 ? (
                            childrens.slice(1).map((child: string, index: number) => (
                                <Box sx={{ display: 'flex' }} key={index}>
                                    <Box sx={styles.containerCircle}>
                                        <Box sx={styles.circle} />
                                    </Box>

                                    <Box>
                                        <Typography sx={styles.textList} variant='text_grey'>
                                            {child}
                                        </Typography>
                                    </Box>
                                </Box>
                            ))
                        ) : (
                            <Typography sx={styles.textList} variant='text_grey'>{t('useScheduled.detail.tables.fromTo')}</Typography>
                        )}
                    </Box>
                )
            },
        },
        {
            id: 'schedule',
            lablel: '',
            contentColumn: {
                justifyContent: 'center',
            },
            rowTdStyles: {
                maxWidth: '20px',
            },
            minWidth: 100,
            headerCell: {
                width: '70px'
            },
            column: () => {
                return (
                    <Box>
                        <IconButton
                            sx={styles.scheduleIcon({
                                mark: false,
                                color: colors.color5
                            })}
                            onClick={(e) => {
                                e.stopPropagation()
                                handleScheduleUser({ id: 'all' })
                            }}
                        >
                            {icons('calendar')}
                        </IconButton>
                    </Box>
                )
            },
            renderCell: (params: any) => {
                const { row } = params
                return (
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <IconButton
                            sx={styles.scheduleIcon({
                                mark: !!row?.checkCalendar,
                            })}
                            onClick={(e) => {
                                e.stopPropagation()

                                handleScheduleUser(row)
                            }}
                        >
                            {icons('calendar')}

                            {(!!row?.checkCalendar) && (
                                <Icon sx={styles.check}>{icons('check')}</Icon>
                            )}
                        </IconButton>
                    </Box >
                )
            },
        },
    ]

    useImperativeHandle(ref, () => ({
        getData: () => {
            return {
                dataList,
                disabledList,
                rows,
                itemWithErrors,
                defaultChecks
            }
        },
        setData: ({ errors, success }) => {
            setRows(prev => prev?.filter(row => !success.some(id => row?.id == id)))
            setDataList(dataList?.filter((list) => !success.some(success => success == list.id)))
            setDefaultChecks(defaultChecks?.filter((id) => !success.some(success => success == id)))
            setItemsWithErrors(errors)
        }
    }))

    const selectCheck = (e: any) => {
        const checks = e.checks.filter((checkId: number) => !disabledList.some(disableId => disableId == checkId))

        props.activeStep(checks)
        setDefaultChecks(checks)
    }

    const onChange: onChange = ({ target }) => {
        const { name, value } = target
        let body = { ...data }
        body = {
            ...data,
            [name]: value,
        }
        if (name == 'openQuestionnaire' && !value) {
            body.from = dayjs().tz(mimTimeZone.code)
            body.to = null
        }

        if (name === 'frequency') {
            body = { ...body, every: null }
            setErrors(prev => ({
                ...prev,
                days: ''
            }))
        }

        if (name === 'dayOfWeek') {
            //const day = dayjs(fromDateDaily).day();
            setStartDate(value)
        }

        if (name === 'duration') {
            const soloNumeros = value?.replace(/\D/g, "");
            let errorMessage = '';
            if (soloNumeros < 1 && !!value) {
                errorMessage = t('general.validations.minimusOneDayToDuration');
            }
            setErrors(prev => ({
                ...prev,
                duration: errorMessage
            }))
        }
        if (['from', 'to'].includes(name)) {
            const from = name == 'from' ? value : data.from
            const to = name == 'to' ? value : data.to

            if (Boolean(from)) {
                let errorMessage = ''
                /* if (dayjs(from).isBefore(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value ?? Constants.defaultTimeZoneObject.value)))) { errorMessage = t('general.validations.minimusCurrentDayStart') } */
                if (dayjs(from).startOf('minute').isBefore(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value ?? Constants.defaultTimeZoneObject.value)).startOf('minute'))) { errorMessage = t('general.validations.minimusCurrentDayStart') }
                setErrors(prev => ({
                    ...prev,
                    from: errorMessage
                }))
            }

            if (Boolean(to)) {
                let errorMessage = ''
                if (dayjs(to).isBefore(dayjs(from).add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') }
                if (dayjs(to).isBefore(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value ?? Constants.defaultTimeZoneObject.value)).add(5, 'minute'))) { errorMessage = t('general.validations.minimusCurrentDay') }
                setErrors(prev => ({
                    ...prev,
                    to: errorMessage
                }))
            }
        }

        if (['startDateDaily', 'endDateDaily'].includes(name)) {
            const startDateDaily = name == 'startDateDaily' ? value : data.startDateDaily
            const endDateDaily = name == 'endDateDaily' ? value : data.endDateDaily

            if (Boolean(endDateDaily)) {
                let errorMessage = ''
                const start = dayjs(startDateDaily);
                const end = dayjs(endDateDaily);
                const diffInMinutes = end.diff(start, 'minute');
                if (diffInMinutes <= 5) { errorMessage = t('general.validations.minimus5minute') }
                setErrors(prev => ({
                    ...prev,
                    endDateDaily: errorMessage
                }))
            }
        }

        if (['fromDateDaily', 'toDateDaily'].includes(name)) {
            const fromDateDaily = name == 'fromDateDaily' ? value : data.fromDateDaily
            const toDateDaily = name == 'toDateDaily' ? value : data.toDateDaily

            if (Boolean(fromDateDaily)) {
                const day = dayjs(fromDateDaily).day();
                setStartDate(day == 0 ? DaysWeek.SUNDAY : day)
            }

            if (Boolean(toDateDaily)) {
                let errorMessage = ''
                const start = dayjs(fromDateDaily);
                const end = dayjs(toDateDaily);
                const diffInDays = end.diff(start, 'day');
                if (diffInDays < 1) { errorMessage = t('general.validations.minimus1Day') }
                setErrors(prev => ({
                    ...prev,
                    toDateDaily: errorMessage
                }))
            }
        }

        if (['fromDateWeekly', 'toDateWeekly'].includes(name)) {
            const fromDateWeekly = name == 'fromDateWeekly' ? value : data.fromDateWeekly
            const toDateWeekly = name == 'toDateWeekly' ? value : data.toDateWeekly
            /* if (Boolean(fromDateWeekly)) {
                const day = dayjs(fromDateWeekly).day();
                setStartDate(day == 0 ? DaysWeek.SUNDAY : day)
            } */
            if (Boolean(toDateWeekly)) {
                let errorMessage = ''
                const start = dayjs(fromDateWeekly);
                const end = dayjs(toDateWeekly);
                const diffInDays = end.diff(start, 'day');
                if (diffInDays < 7) { errorMessage = t('general.validations.minimus7Day') }
                setErrors(prev => ({
                    ...prev,
                    toDateWeekly: errorMessage
                }))
            }
        }

        if (['fromDateCycli', 'toDateCycli'].includes(name)) {
            const fromDateCycli = name == 'fromDateCycli' ? value : data.fromDateCycli
            const toDateCycli = name == 'toDateCycli' ? value : data.toDateCycli

            if (Boolean(fromDateCycli)) {
                const day = dayjs(fromDateCycli).day();
                setStartDate(day == 0 ? DaysWeek.SUNDAY : day)
            }

            if (Boolean(toDateCycli)) {
                let errorMessage = ''
                const start = dayjs(fromDateCycli);
                const end = dayjs(toDateCycli);
                const diffInDays = end.diff(start, 'day');
                if (diffInDays < 1) { errorMessage = t('general.validations.minimus1Day') }
                setErrors(prev => ({
                    ...prev,
                    toDateCycli: errorMessage
                }))
            }
        }

        if (['fromDateDaily', 'toDateDaily', 'days'].includes(name)) {
            const fromDateCycli = name == 'fromDateDaily' ? value : data.fromDateDaily
            const toDateCycli = name == 'toDateDaily' ? value : data.toDateDaily
            const newSelectedDays = selectedDays.map(item => item == 7 ? 0 : item)
            let errorMessage = ''
            let flag: boolean = true;
            if (Boolean(fromDateCycli) && Boolean(toDateCycli)) {
                let current = dayjs(fromDateCycli)
                const end = dayjs(toDateCycli)

                while (current.isSame(end) || current.isBefore(end)) {
                    const dayOfWeek = current.day()
                    if (newSelectedDays.includes(dayOfWeek)) {
                        flag = false;
                    }
                    current = current.add(1, 'day')
                }

                if (flag) { errorMessage = t('general.validations.daysArentValid') }
                setErrors(prev => ({
                    ...prev,
                    days: errorMessage
                }))
            }
        }

        if (['fromDateCycli', 'toDateCycli', 'days', 'duration'].includes(name)) {
            const fromDateCycli = name == 'fromDateCycli' ? value : data.fromDateCycli
            const toDateCycli = name == 'toDateCycli' ? value : data.toDateCycli
            const newSelectedDays = selectedDays.map(item => item == 7 ? 0 : item)
            const duration = name == 'duration' ? value.replace(/[a-zA-Z]/g, '') : data.duration?.replace(/[a-zA-Z]/g, '');
            let errorMessage = ''
            let secondErrorMessage = ''
            let flag: boolean = true;
            if (Boolean(fromDateCycli) && Boolean(toDateCycli)) {
                let current = dayjs(fromDateCycli)
                const end = dayjs(toDateCycli)

                while (current.isSame(end) || current.isBefore(end)) {
                    const dayOfWeek = current.day()
                    if (newSelectedDays.includes(dayOfWeek)) {
                        flag = false;
                    }
                    current = current.add(1, 'day')
                }

                if (flag) { errorMessage = t('general.validations.daysArentValid') }

                const startToValidate = dayjs(fromDateCycli).toDate();
                const endToValidate = dayjs(toDateCycli).toDate();

                const arrayDays = eachDayOfInterval({
                    start: startToValidate,
                    end: endToValidate,
                })
                const dates = arrayDays.filter((day) => newSelectedDays.includes(day.getDay()))
                if (duration > dates.length) {
                    secondErrorMessage = t('general.validations.isUnderTheDatesRange')
                }

                setErrors(prev => ({
                    ...prev,
                    days: errorMessage,
                    duration: secondErrorMessage
                }))
            }
        }

        if (['fromDateWeekly', 'toDateWeekly', 'duration', 'days'].includes(name)) {
            const fromDateCycli = name == 'fromDateWeekly' ? value : data.fromDateWeekly
            const toDateCycli = name == 'toDateWeekly' ? value : data.toDateWeekly
            const newSelectedDays = selectedDays.map(item => item == 7 ? 0 : item)
            const duration = name == 'duration' ? value.replace(/[a-zA-Z]/g, '') : data.duration?.replace(/[a-zA-Z]/g, '');
            let secondErrorMessage = ''
            if (Boolean(fromDateCycli) && Boolean(toDateCycli)) {
                const startToValidate = dayjs(fromDateCycli).toDate();
                const endToValidate = dayjs(toDateCycli).toDate();

                const arrayDays = eachDayOfInterval({
                    start: startToValidate,
                    end: endToValidate,
                })
                const dates = arrayDays.filter((day) => newSelectedDays.includes(day.getDay()))
                if (duration > dates.length) {
                    secondErrorMessage = t('general.validations.isUnderTheDatesRange')
                }

                setErrors(prev => ({
                    ...prev,
                    duration: secondErrorMessage
                }))
            }


        }

        setData(prev => ({ ...prev, ...body }))
    }

    const keepSaveSchedule = () => {
        let errorMessage = ''
        /* if (!data.openQuestionnaire) {
            if (dayjs(data.to).isBefore(dayjs(data.from).add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') }
            if (dayjs(data.to).isBefore(dayjs().add(5, 'minute'))) { errorMessage = t('general.validations.minimusCurrentDay') }
            setErrors(prev => ({
                ...prev,
                to: errorMessage
            }))
        } */
        /* if (data.from && dayjs(data.from).isBefore(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value ?? Constants.defaultTimeZoneObject.value)))) {
            errorMessage = t('general.validations.minimusCurrentDayStart')
            setErrors(prev => ({
                ...prev,
                from: errorMessage
            }))
        } */
        const dataCopy = { ...data }
        dataCopy.children = childrenRef.current;
        dataCopy.selectedDays = selectedDays;
        /* dataCopy.from = data.from;

        if (data.openQuestionnaire) {
            delete dataCopy.from
            delete dataCopy.to
        } */


        if (!errorMessage || data.openQuestionnaire) {
            if (item.id == 'all') {
                setDataList(prev => {
                    const staticList = prev.filter(data => !localeRow.some(row => row.id == data.id))

                    return [...staticList, ...localeRow.map(row => ({
                        ...dataCopy,
                        //from: dataCopy.from ? dayjs(dataCopy.from) : toUnitTimeZone(new Date(), selectedTimeZone.value),
                        //to: dataCopy.to ?? null,
                        children: childrenRef.current,
                        selectedDays: selectedDays,
                        id: row.id,
                    }))]
                })


                setDisabledList(prev => prev.filter(disLis => !localeRow.some(row => row.id == disLis)))
                setRows(prev => prev.map(row => {
                    if (localeRow.some(locale => locale.id == row.id)) {
                        return ({
                            ...row,
                            //from: dataCopy.from ? dayjs(dataCopy.from) : toUnitTimeZone(new Date(), selectedTimeZone.value),
                            //to: dataCopy.to ?? null,
                            children: childrenRef.current,
                            selectedDays: selectedDays,
                            checkCalendar: true
                        })
                    }
                    return row
                }))
                setFlag(true)
                handleCloseScheduleUser()
            } else {
                const dataListCopy = dataList
                const rowCopy = rows
                const foundDataIndex = dataListCopy.findIndex(data => data.id == item.id)
                const rowCopyIndex = rowCopy.findIndex(row => row.id == item.id)
                if (foundDataIndex >= 0) {
                    dataListCopy[foundDataIndex] = dataCopy
                } else {
                    dataListCopy.push(dataCopy)
                }
                const theBiggest = rowCopy[rowCopyIndex].storeTimeZone ?? Constants.defaultTimeZoneObject
                rowCopy[rowCopyIndex] = {
                    ...rowCopy[rowCopyIndex],
                    //from: dataCopy?.from ?? dayjs().tz(theBiggest.code),
                    //to: dataCopy?.to ?? null,
                    children: childrenRef.current,
                    selectedDays: selectedDays,
                    checkCalendar: true
                }

                setDataList(dataListCopy)
                setRows([...rowCopy])
                setDisabledList(prev => prev.filter(id => !dataListCopy.some(data => data.id == id)))
                setFlag(true)
                handleCloseScheduleUser()
            }

            //setChildren([])
        }
    }

    const [mimTimeZone, setmimTimeZone] = useState(Constants.defaultTimeZoneObject)
    // Variable para almacenar la zona horaria seleccionada (por defecto la local)
    const [selectedTimeZone, setSelectedTimeZone] = useState<{ code: string, value?: number }>(Constants.defaultTimeZoneObject);

    useEffect(() => {
        let newSelectedTimeZone: { code: string, value?: number } = { code: '', }

        // Recorrer el array de usuarios y comparar sus zonas horarias con la local
        for (const user of props.listOfItemsToMatch) {
            const { storeTimeZone } = user;
            if (!newSelectedTimeZone.value) {
                newSelectedTimeZone = { code: storeTimeZone.code, value: storeTimeZone.value }
            } else {
                // Si encontramos una zona con un desplazamiento mayor (más al este), la seleccionamos
                if (storeTimeZone?.value > newSelectedTimeZone.value) {
                    newSelectedTimeZone = { code: storeTimeZone.code, value: storeTimeZone.value };
                }
            }
        }
        if (newSelectedTimeZone?.value === undefined || newSelectedTimeZone?.value === null) {
            newSelectedTimeZone = Constants.defaultTimeZoneObject
        }

        setSelectedTimeZone(newSelectedTimeZone);
    }, [props.listOfItemsToMatch/* , selectedTimeZone */])

    const handleScheduleUser = ({ id, questionnaireName, fullName, storeTimeZone }: ObjectGeneric) => {
        let foundData = dataList.find(data => data.id == id)
        setFlag(true)
        if (id === 'all') {
            setSelectedDays([DaysWeek.MONDAY, DaysWeek.TUESDAY, DaysWeek.WEDNESDAY, DaysWeek.THURSDAY, DaysWeek.FRIDAY, DaysWeek.SATURDAY, DaysWeek.SUNDAY])
            const dayjsTimeZone = dayjs(toUnitTimeZone(new Date(), selectedTimeZone.value,))
            setmimTimeZone(selectedTimeZone)
            if (foundData?.from && /* dayjs(foundData.from).isBefore(dayjsTimeZone) */dayjs(foundData.from).startOf('minute').isBefore(dayjsTimeZone.startOf('minute'))) {
                setErrors(prev => ({
                    ...prev,
                    from: t('general.validations.minimusCurrentDayStart')
                }))
            } else {
                setErrors(prev => ({
                    ...prev,
                    from: ''
                }))
            }
            setData(foundData/* ?.from */ ? foundData : { id, from: dayjsTimeZone, frequency: FrequencyEnum.UNIQUE })
        } else {
            const theBiggest = storeTimeZone ?? Constants.defaultTimeZoneObject;
            const deayjsTimeZone = dayjs(toUnitTimeZone(new Date(), theBiggest.value,))
            setmimTimeZone(theBiggest)
            if (foundData?.from && /* dayjs(foundData.from).isBefore(deayjsTimeZone) */dayjs(foundData.from).startOf('minute').isBefore(deayjsTimeZone.startOf('minute'))) {
                setErrors(prev => ({
                    ...prev,
                    from: t('general.validations.minimusCurrentDayStart')
                }))
            } else {
                setErrors(prev => ({
                    ...prev,
                    from: ''
                }))
            }
            setData(foundData/* ?.from */ ? foundData : { id, from: deayjsTimeZone, frequency: FrequencyEnum.UNIQUE }) //Al no tener from no se agrega nada
            if (foundData) {
                setSelectedDays(foundData.selectedDays)
            } else {
                setSelectedDays([DaysWeek.MONDAY, DaysWeek.TUESDAY, DaysWeek.WEDNESDAY, DaysWeek.THURSDAY, DaysWeek.FRIDAY, DaysWeek.SATURDAY, DaysWeek.SUNDAY])
            }
        }

        let errorMessage = ''
        if (foundData?.to && foundData?.from) {
            if (dayjs(foundData?.to).isBefore(dayjs(foundData?.from).add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') }
            if (dayjs(foundData?.to).isBefore(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value ?? Constants.defaultTimeZoneObject.value)).add(5, 'minute'))) { errorMessage = t('general.validations.minimusCurrentDay') }
        }
        setErrors(prev => ({
            ...prev,
            to: errorMessage
        }))

        // if (dayjs(foundData?.to).isBefore(dayjs().tz(timeZone.code))) {
        //     foundData = {
        //         ...foundData,
        //         id,
        //         from: dayjs().tz(timeZone.code),
        //         to: null
        //     }
        // }

        // setData(foundData ?? { id, from: dayjs().tz(timeZone.code) })
        setItem(prev => ({
            ...prev,
            id: id,
            questionnaire: {
                name: questionnaireName ?? ""
            },
            user: {
                name: fullName ?? ""
            },
        }))
    }

    const lookForInvalidateFields = () => {
        if (data?.frequency == FrequencyEnum.UNIQUE) {
            return !(
                Boolean(data?.from) && Boolean(data?.to) && Boolean(data?.frequency) &&
                dayjs(data?.to).isAfter(dayjs(data.from).add(5, 'minute')) &&
                dayjs(data?.to).isAfter(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value,)).add(5, 'minute'))
            )
        }
        if (data?.frequency == FrequencyEnum.DAYLI) {
            return !(
                selectedDays.length !== 0 &&
                Boolean(data?.startDateDaily) && Boolean(data?.endDateDaily) && Boolean(data?.fromDateDaily) && Boolean(data?.toDateDaily) &&
                dayjs(data?.endDateDaily).isAfter(dayjs(data.startDateDaily).add(4, 'minute')) &&
                dayjs(data?.toDateDaily).isAfter(dayjs(data.fromDateDaily))
            )
        }
        if (data?.frequency == FrequencyEnum.WEEKLY) {
            return !(
                selectedDays.length !== 0 &&
                Boolean(data?.startDate) && Boolean(data?.duration) && Boolean(data?.dayOfWeek) && Boolean(data?.endDate) && Boolean(data?.fromDateWeekly) && Boolean(data?.toDateWeekly) &&
                dayjs(data?.toDateWeekly).isAfter(dayjs(data.fromDateWeekly).add(6, 'days')) &&
                selectedDays.includes(data?.dayOfWeek)
            )
        }

        if (data?.frequency == FrequencyEnum.CYCLIC) {
            return !(
                selectedDays.length !== 0 &&
                Boolean(data?.startDate) && Boolean(data?.duration) && Boolean(data?.endDate) && Boolean(data?.fromDateCycli) && Boolean(data?.toDateCycli) &&
                dayjs(data?.toDateCycli).isAfter(dayjs(data.fromDateCycli))
                //validar que sea una semana despues
            )
            //&&
            //validar que sea una semana despues
        }

        return false
        //Aca van las validaciones del disable

    }

    const disabled = () => {
        if (data?.openQuestionnaire) return false
        if (Object.values(errors).some((item: any) => !!item)) return true
        return lookForInvalidateFields()
    }

    const cleanFilter = () => {
        filter.cleanFilter()
    }

    useEffect(() => {
        const checkHeader = refTable.current?.allChecksAreSelected
        if (checkHeader && !!defaultChecks?.length) {
            const activedRows = localeRow.filter(row => !disabledList.some((disLis) => disLis == row.id))
            if (activedRows.length) {
                const areThereActivedRowsNotCheckked = activedRows.some(row => !defaultChecks.some(check => check == row.id))

                checkHeader({ value: !areThereActivedRowsNotCheckked })
            }
        }
    }, [localeRow, defaultChecks])
    return (
        <Box sx={{ position: 'relative' }}>

            <Typography sx={styles.title}>{props.id ? t('schedule.assigned.calendarToOneOrMany') : t('schedule.assigned.calendarToOne')}</Typography>

            <FiltersDrawer
                cleanFilter={cleanFilter}
                count={filter.counter}
                right={-40}
                top={0}
            >
                <Box sx={styles.section}>
                    <DinamicForm
                        errors={errors}
                        input={Object.values({
                            users: {
                                label: 'general.tags.users',
                                translate: true,
                                name: 'users',
                                type: 'filter-select',
                                items: props?.items?.user ?? [],
                                value: null,
                                wrapChildren: ({ children, id }) => {
                                    return (
                                        <Box key={id}>
                                            <Typography sx={{
                                                fontSize: '16px',
                                                fontWeight: '600',
                                                color: '#707070',
                                                marginBottom: '20px',
                                            }}>{t('general.filters')}</Typography>

                                            {children}
                                        </Box>
                                    )
                                }
                            },
                            store: {
                                label: 'general.tags.store',
                                translate: true,
                                name: 'store',
                                type: 'filter-select',
                                items: props?.items?.stores ?? [],
                                value: null,
                            },
                            questionnaires: {
                                label: 'general.tags.questionnaires',
                                translate: true,
                                name: 'questionnaires',
                                type: 'filter-select',
                                items: props?.items?.questionnaire ?? [],
                                value: null,
                            },
                        },)}
                        values={filter.filterData}
                        onChange={filter.onChange}
                    // filter={true}
                    />
                </Box>
            </FiltersDrawer>

            <Grid /* my={3} */ pt={3/*6*/} container spacing={4}>

                <Grid item xs={/* Boolean(item?.id) ? 7.5 : */ 12}>
                    <CustomTable
                        ref={refTable}
                        disabledChecks={disabledList}
                        dontRefresh
                        tableRadio={!!props?.id}
                        tableChecks
                        defaultChecks={defaultChecks ?? []}
                        onClick={selectCheck}
                        column={column}
                        row={localeRow ?? []}
                        selected={-1}
                    />
                </Grid>

                <ConfigCalendar
                    data={data}
                    disabled={disabled}
                    flag={flag}
                    setFlag={setFlag}
                    children={children}
                    childrenRef={childrenRef}
                    setChildren={setChildren}
                    setData={setData}
                    errors={errors}
                    setStartDate={setStartDate}
                    startDate={startDate}
                    selectedDays={selectedDays}
                    setSelectedDays={setSelectedDays}
                    handleCloseScheduleUser={handleCloseScheduleUser}
                    inputModel={inputModel}
                    item={item}
                    keepSaveSchedule={keepSaveSchedule}
                    mimTimeZone={mimTimeZone}
                    onChange={onChange}
                    refRange={refRange}
                    open={Boolean(item?.id)}
                    setErrors={setErrors}
                    itemsStores={props.itemsAll}
                />
            </Grid>
        </Box>
    )
})

export { MatchItems }
